import flagUS from "../../assets/flags/us.svg";
import flagGB from "../../assets/flags/gb.svg";
import flagEU from "../../assets/flags/eu.svg";
import flagCN from "../../assets/flags/cn.svg";
import flagCA from "../../assets/flags/ca.svg";
import flagIN from "../../assets/flags/in.svg";
import flagAU from "../../assets/flags/au.svg";
import flagAE from "../../assets/flags/ae.svg";
import flagSG from "../../assets/flags/sg.svg";
import flagNZ from "../../assets/flags/nz.svg";
import flagKR from "../../assets/flags/kr.svg";
import flagDK from "../../assets/flags/dk.svg";
import flagHK from "../../assets/flags/hk.svg";
import flagTW from "../../assets/flags/tw.svg";
import flagSA from "../../assets/flags/sa.svg";
import flagKW from "../../assets/flags/kw.svg";
import flagQA from "../../assets/flags/qa.svg";
import flagBH from "../../assets/flags/bh.svg";
import flagOM from "../../assets/flags/om.svg";
import flagJO from "../../assets/flags/jo.svg";
import flagIL from "../../assets/flags/il.svg";
import flagTR from "../../assets/flags/tr.svg";
import flagEG from "../../assets/flags/eg.svg";
import flagMA from "../../assets/flags/ma.svg";
import flagDZ from "../../assets/flags/dz.svg";
import flagTN from "../../assets/flags/tn.svg";

/** Each currency's flag (the EU's for the euro), shown round beside its name. */
const CURRENCY_FLAG: Record<string, string> = {
  USD: flagUS,
  GBP: flagGB,
  EUR: flagEU,
  CNY: flagCN,
  CAD: flagCA,
  INR: flagIN,
  AUD: flagAU,
  AED: flagAE,
  SGD: flagSG,
  NZD: flagNZ,
  KRW: flagKR,
  DKK: flagDK,
  HKD: flagHK,
  TWD: flagTW,
  // MENA display currencies (P1D-5557).
  SAR: flagSA,
  KWD: flagKW,
  QAR: flagQA,
  BHD: flagBH,
  OMR: flagOM,
  JOD: flagJO,
  ILS: flagIL,
  TRY: flagTR,
  EGP: flagEG,
  MAD: flagMA,
  DZD: flagDZ,
  TND: flagTN,
};

export default CURRENCY_FLAG;
